import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/apps/loyalty/app/global-error.tsx");
